export default function getRandomIcon(curentIcon = null) {
  let newIcon = allIcons[Math.floor(Math.random() * allIcons.length)];
  while (curentIcon && newIcon === curentIcon)
    newIcon = allIcons[Math.floor(Math.random() * allIcons.length)];
  return newIcon;
}

const allIcons = [
  "alarm-clock far",
  "align-left far",
  "amp-guitar fad",
  "angel fas",
  "archway fad",
  "baby fad",
  "baby-carriage fad",
  "backpack fad",
  "bacteria fad",
  "badge fad",
  "ballot fad",
  "balance-scale-right fad",
  "baseball fad",
  "basketball-hoop fad",
  "bed-bunk fad",
  "bells fad",
  "bible fad",
  "book-reader fad",
  "bookmark fad",
  "books fad",
  "bow-arrow fad",
  "box-full fad",
  "box-heart fad",
  "bread-loaf fad",
  "browser fad",
  "building fad",
  "bullhorn fad",
  "bus-school fad",
  "calendar-alt fad",
  "calendar-check fad",
  "camera fad",
  "camera-movie fad",
  "campfire fad",
  "candle-holder fad",
  "car-side fad",
  "chalkboard fad",
  "check-double fad",
  "chart-line fad",
  "chart-bar fad",
  "cheeseburger fad",
  "child fad",
  "church fad",
  "city fad",
  "clipboard-list-check fad",
  "cloud-sun fad",
  "coffee-togo fad",
  "coins fad",
  "compass fad",
  "cookie-bite fad",
  "cross far",
];
